<template>
  <div v-if="$apollo.loading">
    <spinner />
  </div>
  <div v-else class="wrapper">
    <v-flex class="title-screen" xs12>
      <span>{{ adminText('workflowsAll.visitor_statistics_d28c229', 'Visitor statistics') }}</span>
    </v-flex>
    <v-select
      v-model="selectedEventId"
      :items="workflowUi(performanceDates)"
      :label="adminText('workflowsAll.performance_63c9045', 'Performance')"
      :item-text="item => workflowPerformanceOption(item)"
      item-value="id"
      box
      style="max-width: 1000px"
    />
    <div class="graphs-container">
      <div class="first-row">
        <visitors-total-number
          :event-id="selectedEventId"
          :event-template-id="eventTemplateId"
          :initial-date-range-option="initialDateRangeOption"
          :initial-date-range="[startDate, endDate]"
        />
        <visitors-by-age-and-gender
          :event-id="selectedEventId"
          :event-template-id="eventTemplateId"
          :initial-date-range-option="initialDateRangeOption"
          :initial-date-range="[startDate, endDate]"
        />
      </div>
      <div class="second-row">
        <visitor-by-city-stats
          :event-id="selectedEventId"
          :event-template-id="eventTemplateId"
          :initial-date-range-option="initialDateRangeOption"
          :initial-date-range="[startDate, endDate]"
        />
        <visitors-by-source
          :event-id="selectedEventId"
          :event-template-id="eventTemplateId"
          :initial-date-range-option="initialDateRangeOption"
          :initial-date-range="[startDate, endDate]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import VisitorByCityStats from './visitor-by-city-stats.vue'
import VisitorsBySource from './visitors-by-source.vue'
import VisitorsTotalNumber from './visitors-total-number.vue'
import VisitorsByAgeAndGender from './visitors-by-age-and-gender.vue'
import moment from 'moment'

import { GET_EVENTS_BY_EVENT_TEMPLATE_ID } from '../../../graphql/event.graphql'

export default {
  mixins: [WorkflowDisplay],
  name: 'theater-visitor-stats-container',
  components: {
    VisitorByCityStats,
    VisitorsBySource,
    VisitorsTotalNumber,
    VisitorsByAgeAndGender,
  },
  props: {
    eventId: String,
    user: Object,
    organizationSlug: null,
    eventTemplateId: null,
  },
  data() {
    return {
      event: null,
      initialDateRangeOption: null,
      endDate: null,
      startDate: null,
      performanceDates: [],
      selectedEventId: null,
    }
  },
  apollo: {
    getEventsByEventTemplateId: {
      query: GET_EVENTS_BY_EVENT_TEMPLATE_ID,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
          eventTemplateId: this.eventTemplateId,
        }
      },
      result({ data: { getEventsByEventTemplateId } }) {
        this.performanceDates = [
          { id: null, from: 'All performances' },
          ...getEventsByEventTemplateId.sort((a, b) => new Date(b.from) - new Date(a.from)).map(p => {
            return { ...p, from: p.from }
          }),
        ]

        const maxEventEnd = moment.max(...getEventsByEventTemplateId.map(p => moment(p.to)))

        const eventHasEndedMoreThanWeekAgo = maxEventEnd.add(1, 'week').isBefore(new Date())
        this.initialDateRangeOption = eventHasEndedMoreThanWeekAgo ? 3 : 1
        this.endDate = eventHasEndedMoreThanWeekAgo
          ? maxEventEnd.add(1, 'week').format('YYYY-MM-DD')
          : moment(new Date()).format('YYYY-MM-DD')
        this.startDate = eventHasEndedMoreThanWeekAgo
          ? maxEventEnd.subtract(1, 'week').format('YYYY-MM-DD')
          : moment(new Date()).subtract(1, 'week').format('YYYY-MM-DD')
      },
    },
  },
}
</script>

<style scoped>
.graphs-container {
  display: flex;
  flex-direction: column;
}
.first-row {
  display: flex;
  flex-direction: row;
  margin-bottom: 76px;
}
.first-row div:first-child {
  margin-right: 30px;
}
.second-row {
  display: flex;
  flex-direction: row;
}
.second-row div:first-child {
  margin-right: 30px;
}

@media only screen and (max-width: 1415px) {
  .first-row {
    flex-direction: column;
  }
  .second-row {
    flex-direction: column;
  }
  .first-row {
    margin-bottom: 32px;
  }

  .first-row div:first-child {
    margin-right: 0px;
    margin-bottom: 32px;
  }

  .second-row div:first-child {
    margin-right: 0px;
    margin-bottom: 32px;
  }
}

@media only screen and (max-width: 800px) {
  .first-row {
    flex-direction: column;
  }
  .second-row {
    flex-direction: column;
  }
  .first-row {
    margin-bottom: 32px;
  }

  .first-row div:first-child {
    margin-right: 0px;
    margin-bottom: 32px;
  }

  .second-row div:first-child {
    margin-right: 0px;
    margin-bottom: 32px;
  }
  .graphs-container {
    align-items: center;
  }
}
@media screen and (max-width: 800px) {
  .wrapper {
    margin-top: 1.5rem;
  }
}
</style>
